var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZan1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 239,
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19616 128.5C1.98077 122.931 1.98077 116.069 5.19616 110.5L54.5539 25.01C57.7692 19.4408 63.7115 16.01 70.1423 16.01L168.858 16.01C175.288 16.01 181.231 19.4408 184.446 25.01L233.804 110.5C237.019 116.069 237.019 122.931 233.804 128.5L184.446 213.99C181.231 219.559 175.289 222.99 168.858 222.99L70.1423 222.99C63.7115 222.99 57.7693 219.559 54.5539 213.99L5.19616 128.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZan1);
export default __webpack_public_path__ + "static/media/zan1.4340a1c38df7e5f3e248863147a38057.svg";
export { ForwardRef as ReactComponent };